import { ReloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Form, Spin } from 'antd';
import moment from 'moment';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { HAPUS_IFUNDEFINE } from 'services';
import _Api from 'services/Api/_Api';
import { Button_, Input_, Number_, Select_ } from 'services/Forms/FormsSatu';
import { msg } from 'services/Toastr/Notify/_Toastr';


function KebutuhanEnergiMakronutrien({ frm }) {


    const listKebutuhanEnergi = [
        { name: "energi", label: "Energi",  disabled: true, satuan: "kcal" },
        { name: "protein", label: "Protein", disabled: true, satuan: "g" },
        { name: "lemak_g", label: "Lemak", disabled: true, satuan: "g" },
        { name: "kh_g", label: "KH", disabled: true, satuan: "g" },
    ]


    const listKebutuhanEnergiTeori = [
        { name: "energi", label: "Energi", disabled: true, satuan: "kcal" },
        { name: "protein", label: "Protein", disabled: true, satuan: "g" },
        { name: "lemak_g_teori", label: "Lemak", disabled: true, satuan: "g" },
        { name: "kh_g_teori", label: "KH", disabled: true, satuan: "g" },
    ]


    const listPenggunaanMateri = [
        { "id": 1, "label": "Mifflin St Jeor" },
        { "id": 2, "label": "Ireton-Jones 2002" },
        { "id": 3, "label": "Ireton-Jones 1992" },
        { "id": 4, "label": "Spontaneous breathing" },
        { "id": 5, "label": "Rumus Cepat" }
    ]
    const listPenentuanProtein = [
        { "id": 1, "label": "Persentase (%)" },
        { "id": 2, "label": "g/kgBB" },
    ]

    function hitungEnergi(c47, b31, b37, b38, b39, b42) {
        switch (c47) {
            case 1:
                return b31;
            case 2:
                return b37;
            case 3:
                return b38;
            case 4:
                return b39;
            default:
                return b42;
        }
    }
    function formatRibuan(angka) {
        return new Intl.NumberFormat('en-US').format(angka);
    }

    const getNumber = (field) => {
        const raw = frm.getFieldValue(field)
        if (raw === undefined || raw === null || raw === '') return 0
        return parseFloat(String(raw).replace(/,/g, '')) || 0
    }

    const hitungNilaiProtein = (energiValue) => {
        const b48 = frm.getFieldValue("penentian_protein") ?? ""
        const b49 = getNumber("protein_bbrapag_kgBB")
        const b50 = getNumber("atauproteinberapaenergi")
        const b12 = getNumber("bb")

        switch (b48) {
            case 1: // persen energi
                return ((b50 * energiValue) / 100) / 4
            case 2: // g/kgBB
                return b49 * b12
            default:
                return 0
        }
    }

    const hitungSemua = () => {
        let c47 = parseInt(frm.getFieldValue("rumus_energi") ?? 0)
        let b31 = getNumber("tee")
        let b37 = getNumber("ireton_jones_2002")
        let b38 = getNumber("ireton_jones_1992")
        let b39 = getNumber("spontaneous_breathing")
        let b42 = getNumber("energi_kcal")
        let b53 = getNumber("lemakberapa_persen")
        const C54 = getNumber("KH_berapa_teori")

        const energi = parseFloat(hitungEnergi(c47, b31, b37, b38, b39, b42)) || 0
        const protein = hitungNilaiProtein(energi) || 0
        const kh_g_teori = (C54 * energi / 4) / 100
        const lemak_g = ((b53 * energi) / 9) / 100

        const kh_g = (energi - (protein * 4) - (lemak_g * 9)) / 4
        // const lemak_g_teori = ((energi - (protein * 4)) - (kh_g_teori * energi / 100 * 4)) / 9
        const lemak_g_teori =(energi-(protein*4)-(kh_g_teori*4))/9
        const lemakberapa_persen_teori = energi !== 0 ? (lemak_g_teori * 9 / energi) * 100 : 0

    
        const kh_berapa = energi !== 0 ? (((kh_g * 4) / energi) * 100).toFixed(1) : 0

        frm.setFieldsValue({
            energi: formatRibuan(energi.toString()),
            protein: protein.toFixed(1).toString(),
            lemak_g: lemak_g.toFixed(1),
            lemak_g_teori: lemak_g_teori.toFixed(1),
            kh_g_teori: kh_g_teori.toFixed(1),
            kh_g: kh_g.toFixed(1),
            KH_berapa: kh_berapa,
            lemakberapa_persen_teori: lemakberapa_persen_teori.toFixed(1),
        })
    }


    return (
        <Row>
            <Col sm="1" > </Col>
            <Col sm="4" className='border p-3'>
                <Form form={frm} layout='vertical' style={{ marginLeft: "30px" }} onValuesChange={hitungSemua}>
                    <Select_ label="Penentuan Protein" name="penentian_protein" option={listPenentuanProtein} val="id" caption="label" />
                    <Input_ addonAfter="Kg" name="protein_bbrapag_kgBB" label="Protein berapa g/kgBB " />
                    <Input_ addonAfter="%" max={100} name="atauproteinberapaenergi" label="Atau protein berapa % energi? " />
                    <Input_ disabled value="Protein, Lemak, KH by difference" label="Yang ditentukan:" />
                    <Input_ addonAfter="%" max={100} name="lemakberapa_persen" label="Lemak berapa %?" />
                    <Input_ addonAfter="%"   max={100} name="KH_berapa" disabled label="KH berapa %?" />
                    {
                        listKebutuhanEnergi.map((v, i) => (
                            <div key={i} className="col-sm-12 hover">
                                <div className='row pt-2'>
                                    <div className="col-sm-3 text-right" style={{ textAlign: 'right' }}>
                                        <label className=' text-right'>{v.label} : </label>
                                    </div>
                                    <div className="col-sm-9">
                                        <div className="form-group">
                                            {
                                                v.tipe == "number" ?
                                                    <Number_ addonAfter={v.satuan} name={v.name} />
                                                    :
                                                    <Input_ addonAfter={v.satuan} name={v.name} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </Form>
            </Col>
            <Col sm="4" className='border p-3'>
                <Form form={frm} layout='vertical' style={{ marginLeft: "30px" }} onValuesChange={hitungSemua}>
                    <Select_ label="Rumus energi yg dipakai" name="rumus_energi" option={listPenggunaanMateri} val="id" caption="label" />
                    {/* <Input_ onChange={hitungSemua}  addonAfter="Kg" name="protein_bbrapag_kgBB" label="Protein berapa g/kgBB " />
                            <Number_ onChange={hitungSemua}  addonAfter="%" max={100} name="atauproteinberapaenergi" label="Atau protein berapa % energi? " /> */}
                    <Input_ disabled value="Protein, KH, lemak sisanya" label="Yang ditentukan:" />
                    <Input_ addonAfter="%" max={100} name="lemakberapa_persen_teori" disabled label="Lemak berapa %?" />
                    <Input_ suffix="%" max={100} name="KH_berapa_teori" label="KH berapa %?" />
                    {
                        listKebutuhanEnergiTeori.map((v, i) => (
                            <div key={i} className="col-sm-12 hover">
                                <div className='row pt-2'>
                                    <div className="col-sm-3 text-right" style={{ textAlign: 'right' }}>
                                        <label className=' text-right'>{v.label} : </label>
                                    </div>
                                    <div className="col-sm-9">
                                        <div className="form-group">
                                            {
                                                v.tipe == "number" ?
                                                    <Number_ addonAfter={v.satuan} disabled={v.disabled} name={v.name} />
                                                    :
                                                    <Input_ addonAfter={v.satuan} disabled={v.disabled} name={v.name} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </Form>
            </Col>
                    <div className="text-center mt-3">
                        <Button_
                            type="primary"
                            icon={<ReloadOutlined />}
                            onClick={hitungSemua}
                            label=" Hitung Ulang"
                        >
                           
                        </Button_>
                    </div>

        </Row>
    )
}

export default KebutuhanEnergiMakronutrien